import React, { type CSSProperties, type ReactNode } from 'react';
import cx from 'classnames';
import { styles } from '@resources/js/helpers/styles';

type SkeletonBoxProps = {
  className?: string;
  style?: CSSProperties;
  level?: 1 | 2;
  children?: ReactNode;
};

export default function SkeletonBox({
  className,
  style,
  level,
  children,
}: SkeletonBoxProps) {
  return (
    <span
      className={cx([
        'skeleton-box',
        level && `skeleton-box--level-${level}`,
        className,
      ])}
      style={style}
    >
      {children ? (
        <span className={'skeleton-box__content'}>{children}</span>
      ) : null}
    </span>
  );
}

export function SkeletonBoxFill({
  className,
  style,
  level = 1,
  margin = styles.tinyGap,
}: SkeletonBoxProps & { margin?: number }) {
  style ??= {
    ...(style ?? {}),
    width: `calc(100% - ${margin * 2}px`,
    height: `calc(100% - ${margin * 2}px`,
    margin,
  };

  return <SkeletonBox className={className} style={style} level={level} />;
}
